import { useEffect, useRef } from "react";

export default function Turnstile({ onVerify }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!window.turnstile) return;

    const widgetId = window.turnstile.render(ref.current, {
      sitekey: "0x4AAAAAACzWgwOM6fZYfhb1", // SITE KEY
      callback: (token) => {
        onVerify(token);
      },
      theme: "light",
    });

    return () => {
      if (window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    };
  }, []);

  return <div ref={ref} />;
}